import {StreamActions} from "@hotwired/turbo"

StreamActions.reload = function () {
    const target = this.targetElements[0]
    if (target && typeof target.reload === 'function') {
        console.log(`TurboStream: reloading frame ${target.id}`);
        target.reload();
    } else if (target) {
        console.warn(`TurboStream: target ${target.id} is not a reloadable frame`);
    }
}

StreamActions.refresh = function () {
    console.log("TurboStream: refreshing page");
    Turbo.visit(window.location.pathname, {action: "replace"});
}
